/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module select-all
 */
export { default as SelectAll } from './selectall.js';
export { default as SelectAllEditing } from './selectallediting.js';
export { default as SelectAllUI } from './selectallui.js';
import './augmentation.js';
